import { OverlayContainer } from '@angular/cdk/overlay'
import { Injectable } from '@angular/core'

@Injectable()
export class FlxOverlayContainer extends OverlayContainer {
  override _createContainer(): void {
    const container = document.createElement('div')
    container.classList.add('cdk-overlay-container')

    // Change this to your desired parent element
    const customParent = document.querySelector('#overlay-root')

    if (customParent) {
      customParent.appendChild(container)
    } else {
      document.body.appendChild(container) // fallback
    }

    this._containerElement = container
  }
}
